export const TENANT_URL_TOKEN = '{YourTenantNumber}';

export const BHOM_TEMPLATE = `https://${TENANT_URL_TOKEN}-itom-demo.onbmc.com`;

export const ITSM_TEMPLATE = `https://${TENANT_URL_TOKEN}-demo-restapi.onbmc.com`;

export const isTemplateOrContainsToken = (val = '') => {
  const v = String(val || '').trim();
  return !v || v === BHOM_TEMPLATE || v === ITSM_TEMPLATE || v.includes(TENANT_URL_TOKEN);
};

export const expandIfJustTenantNumber = (val = '', template = BHOM_TEMPLATE) => {
  const v = String(val || '').trim();
  if (!v) return '';
  if (/^[a-zA-Z0-9]+$/.test(v) && !v.includes('http')) {
    return template.replace(TENANT_URL_TOKEN, v);
  }
  return v;
};

export const selectTenantSegment = (inputEl, currentValue) => {
  if (!inputEl) return;
  const v = String(currentValue || '');

  const tokenIdx = v.indexOf(TENANT_URL_TOKEN);
  if (tokenIdx >= 0) {
    const start = tokenIdx;
    const end = tokenIdx + TENANT_URL_TOKEN.length;
    requestAnimationFrame(() => inputEl.setSelectionRange(start, end));
    return;
  }

  const match = v.match(/^https?:\/\/([^/]+?)-(itom-demo|demo-restapi)\.onbmc\.com/i);
  if (match?.[1]) {
    const tenantPart = match[1];
    const start = v.indexOf(tenantPart);
    const end = start + tenantPart.length;
    if (start >= 0) {
      requestAnimationFrame(() => inputEl.setSelectionRange(start, end));
    }
  }
};

export const normalizeTenantUrlBlur = (value, template = BHOM_TEMPLATE) => {
  const v = String(value || '').trim();
  if (isTemplateOrContainsToken(v)) {
    return '';
  }
  return expandIfJustTenantNumber(v, template);
};
